var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowBelowIos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_35477",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 10,
    height: 10
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 4.37114e-7,
    width: 10,
    height: 10,
    transform: "rotate(90 10 4.37114e-07)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_35477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.28557 3.05855C1.37532 2.9688 1.47908 2.92393 1.59686 2.92393C1.71465 2.92393 1.81841 2.9688 1.90816 3.05855L4.99871 6.1491L8.09968 3.04813C8.18514 2.96266 8.28477 2.91992 8.39855 2.91992C8.51233 2.91992 8.61542 2.96613 8.70783 3.05855C8.79063 3.14135 8.83203 3.24337 8.83203 3.36463C8.83203 3.48589 8.79063 3.58792 8.70783 3.67071L5.28316 7.0994C5.23722 7.14534 5.19088 7.17806 5.14414 7.19756C5.0974 7.21705 5.04892 7.2268 4.99871 7.2268C4.94849 7.2268 4.90002 7.21705 4.85328 7.19756C4.80654 7.17806 4.7602 7.14534 4.71426 7.0994L1.27516 3.6603C1.18274 3.56789 1.14 3.46586 1.14695 3.35421C1.15389 3.24257 1.2001 3.14401 1.28557 3.05855Z",
    fill: "#9CA3AF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBelowIos);
export default __webpack_public_path__ + "static/media/arrow_below_ios.c68af54f83c69621eb43a6987c8346dc.svg";
export { ForwardRef as ReactComponent };